import React from "react"
import BannerBlog from "../components/BannerBlog"
import FeaturedPosts from "../components/overview/FeaturedPosts"
import Layout from "../components/Layout"
import NavBlog from "../components/NavBlog"
import PopularPosts from "../components/overview/PopularPosts"
import Seo from "../components/Seo"
import FooterBanner from "../components/FooterBanner"
import Category from "../components/overview/Category"

const Blog = () => {
  return (
    <Layout>
      <Seo Sitetitle="Blog" />
      <NavBlog />
      <BannerBlog />
      <FeaturedPosts />
      <PopularPosts />
      <Category />
      <FooterBanner />
    </Layout>
  )
}

export default Blog
